/** Before/After — photo compare slider + metrics timeline */
(function () {
  document.querySelectorAll('[data-zm-before-after]').forEach((section) => {
    const compare = section.querySelector('[data-zm-ba-compare]');
    const compareRange = section.querySelector('[data-zm-ba-compare-range]');
    const beforeLayer = section.querySelector('[data-zm-ba-before-layer]');
    const handle = section.querySelector('[data-zm-ba-handle]');

    function setCompare(v) {
      if (!beforeLayer || !handle) return;
      beforeLayer.style.width = `${v}%`;
      handle.style.left = `${v}%`;
    }

    if (compare && compareRange) {
      const stage = compare.querySelector('.zm-ba-compare__stage');
      const beforeImg = compare.querySelector('.zm-ba-compare__img--before');

      function syncBeforeWidth() {
        if (!stage || !beforeImg) return;
        beforeImg.style.width = `${stage.offsetWidth}px`;
        beforeImg.style.maxWidth = 'none';
      }

      syncBeforeWidth();
      window.addEventListener('resize', syncBeforeWidth);

      compareRange.addEventListener('input', (e) => setCompare(Number(e.target.value)));
      setCompare(Number(compareRange.value));

      let autoPlayed = false;
      const ioCompare = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || autoPlayed) return;
            autoPlayed = true;
            /* Brief reveal: start mid, nudge toward after, settle at 50% so both stay clear */
            let v = 58;
            const target = 50;
            const tick = () => {
              v += (target - v) * 0.08;
              if (Math.abs(target - v) < 0.4) v = target;
              compareRange.value = v;
              setCompare(v);
              if (v !== target) requestAnimationFrame(tick);
            };
            setTimeout(() => requestAnimationFrame(tick), 500);
          });
        },
        { threshold: 0.35 }
      );
      ioCompare.observe(compare);
    }

    const baRange = section.querySelector('[data-zm-ba-range]');
    const painFill = section.querySelector('[data-zm-pain-fill]');
    const sleepFill = section.querySelector('[data-zm-sleep-fill]');
    const mobilityFill = section.querySelector('[data-zm-mobility-fill]');
    const painVal = section.querySelector('[data-zm-pain-val]');
    const sleepVal = section.querySelector('[data-zm-sleep-val]');
    const mobilityVal = section.querySelector('[data-zm-mobility-val]');

    if (!baRange || !painFill || !sleepFill || !mobilityFill) return;

    function updateBA(v) {
      const p = v / 100;
      const painPct = 80 - 60 * p;
      painFill.style.clipPath = `inset(0 ${100 - painPct}% 0 0)`;
      const sleepPct = 25 + 65 * p;
      sleepFill.style.clipPath = `inset(0 ${100 - sleepPct}% 0 0)`;
      const mobPct = 30 + 60 * p;
      mobilityFill.style.clipPath = `inset(0 ${100 - mobPct}% 0 0)`;

      if (v < 15) {
        painVal.textContent = '8 / 10';
        sleepVal.textContent = 'Poor';
        mobilityVal.textContent = 'Limited';
      } else if (v > 85) {
        painVal.textContent = '2 / 10';
        sleepVal.textContent = 'Restful';
        mobilityVal.textContent = 'All-day comfort';
      } else {
        painVal.textContent = `${Math.round(8 - 6 * p)} / 10`;
        sleepVal.textContent = 'Improving';
        mobilityVal.textContent = 'Improving';
      }
    }

    baRange.addEventListener('input', (e) => updateBA(Number(e.target.value)));
    updateBA(0);

    let baPlayed = false;
    const ioBA = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || baPlayed) return;
          baPlayed = true;
          let v = 0;
          const step = () => {
            v += 1.5;
            baRange.value = v;
            updateBA(v);
            if (v < 100) requestAnimationFrame(step);
          };
          setTimeout(() => requestAnimationFrame(step), 900);
        });
      },
      { threshold: 0.3 }
    );
    ioBA.observe(section);
  });
})();
